import { subscribe } from "@shared/utils.events"
import { useSegment } from "./useSegment"

export const useSwiperTracking = (): (() => void) => {
  const { track } = useSegment()

  return () => {
    subscribe("swiper.onslidechange", ({ target, position }) => {
      track({
        event: "Page Element Viewed",
        properties: {
          module_content: target as never,
          module_content_details: `Position: ${position}` as never,
        },
      })
    })
  }
}
